export default "__VITE_ASSET__DKR4XGcl__"